/**
 * Generates a URL for the Google Maps static image API endpoint.
 *
 * @param options - The configuration options for the image URL
 * @param options.productShortId - Optional product short ID to include in the URL
 * @param options.outfitterShortId - Optional outfitter short ID to include in the URL
 * @param options.lat - Latitude coordinate (required for cache busting)
 * @param options.lng - Longitude coordinate (required for cache busting)
 * @param options.origin - Optional origin (e.g., https://adventures.polaris.com) to generate full URL
 * @returns A URL string pointing to the Google Maps static image API endpoint
 */
export function getGoogleMapsStaticImageUrl({
  productShortId,
  outfitterShortId,
  lat,
  lng,
  origin
}: {
  productShortId?: string
  outfitterShortId?: string
  lat: number
  lng: number
  origin?: string
}) {
  const searchParams = new URLSearchParams()
  if (productShortId) searchParams.append('productShortId', productShortId)
  if (outfitterShortId) searchParams.append('outfitterShortId', outfitterShortId)

  if (!productShortId && !outfitterShortId) {
    throw new Error('Outfitter or product not specified')
  }

  searchParams.append('lat', lat.toString())
  searchParams.append('lng', lng.toString())

  const baseUrl = origin?.includes('adventures.polaris.com') ? 'https://adventures.poladv.com' : ''
  return `${baseUrl}/api-v2/google-maps-image?${searchParams.toString()}`
}
